<template>
  <div class="floorplan">
     <ul class="switch">
      <li :class="{ active: level === 'ground' }" @click="setLevel('ground')">Ground</li>
      <li :class="{ active: level === 'first' }" @click="setLevel('first')">1st floor</li>
      <li :class="{ active: level === 'second' }" @click="setLevel('second')">2nd floor</li>
    </ul>
    <br /><br />
    <div class="level">
      <img v-if="level === 'ground'" src="/images/plans/ground.png" rel="preload" />
      <img v-if="level === 'first'" src="/images/plans/first.png" rel="preload" />
      <img v-if="level === 'second'" src="/images/plans/second.png" rel="preload" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    level: {
      type: String,
      default: "ground"
    },
    overlay: {
      type: String,
      default: ""
    }
  },
  methods: {
    setLevel(floor) {
      this.level = floor;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./../theme/index.scss";

.floorplan {
  margin-bottom: 64px;
}

img {
  width: 100%;
  margin-top: 32px;
}

h4 {
  margin-top: -32px;
  margin-bottom: 48px;
}

.switch {
  display: flex;
  list-style: none;
  justify-content: center;
  padding: 0;
  margin: 0;

  @media (max-width: 680px) {
    flex-direction: column;
    margin-top: 32px;

    li {
      width: 100%;
      margin-top: -1px;
    }
  }

  li {
    width: 128px;
    align-self: center;
    display: block;
    border: 1px solid $primary;
    background: none;
    color: $primary;
    padding: 12px 24px 12px;
    font-family: $font-heading;
    font-size: 12px;
    line-height: 20px;
    margin-left: -1px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 2px;
    cursor: pointer;

    &.active {
      background: $primary;
      color: $secondary;
    }
  }
}
</style>